module.exports = "<h2><mat-icon style=\"vertical-align: middle\">error</mat-icon>&nbsp;L'operazione non può essere effettuata</h2>\n<p>Il servizio è disponibile solo per l'Italia. Controllare bene l'indirizzo immesso.</p>\n\n<div style=\"margin-top: 10px; text-align: right\">\n  <button mat-raised-button (click)=\"closeDialog()\">Chiudi</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/incorrect-country-dialog/incorrect-country-dialog.html
// module id = ./src/app/dialogs/incorrect-country-dialog/incorrect-country-dialog.html
// module chunks = main